import {Component, ViewChild} from '@angular/core';
import {DayPilot, DayPilotGanttComponent} from "daypilot-pro-angular";

@Component({
  selector: 'app-gantt',
  template: ` 
  <daypilot-gantt #gantt1 [config]="config"></daypilot-gantt>
  `,
  styleUrls: ['./gantt.component.scss']
})
export class GanttComponent  {

  // @ViewChild('gantt1', {static: false})
  @ViewChild('gantt1')

  gantt1: DayPilotGanttComponent;

  config: any = {
    startDate: "2020-03-01",
    days: new DayPilot.Date("2020-03-01").daysInMonth(),
    cellWidthSpec: "Auto",
    tasks:
    //  [
    //   {start: "2020-03-05", end: "2020-03-07", id: 1, text: "Task 1", complete: 50}
    //  ]
    [
      {"id":"1","text":"Centre Médico-Sociale","start":null,"end":null,"complete":"0","children":
        [
          {"id":"2","text":"Rasolofondraibe Victor Thierry","start":"2020-03-05T00:00:00","end":"2020-03-10T00:00:00","complete":"30"},
          {"id":"3","text":"RAKOTONDRANAIVO Ronnah Ainatiana","start":"2020-03-10T00:00:00","end":"2020-03-15T00:00:00","complete":"75"},
          {"id":"4","text":"ANDRIAMANGA Zafy Cécilia ","start":"2020-03-09T00:00:00","end":"2020-03-09T00:00:00","complete":"0","type":"Milestone"}
        ]
      },
      {"id":"5","text":"SLC","start":null,"end":null,"complete":"0","children":
        [
          {"id":"6","text":"Mr Joslin","start":"2020-03-05T00:00:00","end":"2020-03-10T00:00:00","complete":"30"},
          {"id":"7","text":"Mm Tiana","start":"2020-03-10T00:00:00","end":"2020-03-15T00:00:00","complete":"75"},
          {"id":"8","text":"Chef SLC","start":"2020-03-05T00:00:00","end":"2020-03-10T00:00:00","complete":"30"},        
        ]
      },
      {"id":"9","text":"SE","start":null,"end":null,"complete":"0","children":
        [
          {"id":"10","text":"Mr Joslin","start":"2020-03-05T00:00:00","end":"2020-03-10T00:00:00","complete":"30"},
          {"id":"11","text":"Mm Tiana","start":"2020-03-10T00:00:00","end":"2020-03-15T00:00:00","complete":"75"},
          {"id":"12","text":"Chef SLC","start":"2020-03-09T00:00:00","end":"2020-03-09T00:00:00","complete":"0","type":"Milestone"}
        ]
      },
      {"id":"13","text":"SCAF","start":null,"end":null,"complete":"0","children":
        [
          {"id":"14","text":"Mm Ravo","start":"2020-03-05T00:00:00","end":"2020-03-10T00:00:00","complete":"30"},
          {"id":"15","text":"Mr Obel","start":"2020-03-10T00:00:00","end":"2020-03-15T00:00:00","complete":"75"},
          {"id":"16","text":"Chef SCAF","start":"2020-03-09T00:00:00","end":"2020-03-09T00:00:00","complete":"0","type":"Milestone"}
        ]
      },
      {"id":"17","text":"DAF","start":null,"end":null,"complete":"0","children":
      [
        {"id":"18","text":"Tsirivelo","start":"2020-03-05T00:00:00","end":"2020-03-10T00:00:00","complete":"30"},
        {"id":"19","text":"Michael","start":"2020-03-10T00:00:00","end":"2020-03-15T00:00:00","complete":"75"},
        {"id":"20","text":"Mm Oly ","start":"2020-03-09T00:00:00","end":"2020-03-09T00:00:00","complete":"0","type":"Milestone"}
      ]
    }
    ]
    
  };

}
